// @flow

import type {Account, Merchant} from 'docs/data';

export type GetLoginUrlOptions = {|
  account: Account,
  merchant?: Merchant,
  returnUrl?: string,
|};

export const getLoginUrl = ({
  account,
  merchant,
  returnUrl,
}: GetLoginUrlOptions) => {
  const redirect = returnUrl ? encodeURIComponent(returnUrl) : null;
  let url;
  if (merchant) {
    url = `${account.dashboardUrl}/b/${merchant.token}?force_merchant_login=true`;
    if (redirect) {
      url += `&destination=${redirect}`;
    }
  } else {
    url = `${account.dashboardUrl}/login`;
    if (redirect) {
      url += `?redirect=${redirect}`;
    }
  }

  return url;
};
